declare const __RAIDLENS_VERSION__: string;
declare const __RAIDLENS_COMMIT__: string;

const version =
  typeof __RAIDLENS_VERSION__ === "string" ? __RAIDLENS_VERSION__ : "dev";
const commit =
  typeof __RAIDLENS_COMMIT__ === "string" ? __RAIDLENS_COMMIT__ : "local";

export const dashboardBuild = `v${version} · ${commit}`;
